import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "receipt-edit-modal" }
const _hoisted_2 = { class: "edit-header" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = { class: "edit-preview" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "edit-form" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "edit-actions" }
const _hoisted_10 = ["disabled"]

import { ref, computed, watch } from 'vue'
import YmdDateInput from '@/components/common/YmdDateInput.vue'
import api from '@/services/api'

interface Receipt {
  idx?: number
  fileName: string
  url?: string
  scanDate?: string
  description?: string
  fileUrl?: string
  mCode?: string
  matched?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReceiptEditModal',
  props: {
    modelValue: { type: Boolean },
    receipt: {},
    mCode: {}
  },
  emits: ["update:modelValue", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const saving = ref(false)
const form = ref({
  scanDate: '',
  description: ''
})

const imageUrl = computed(() => {
  if (!props.receipt) return ''
  if (props.receipt.fileUrl) return props.receipt.fileUrl
  if (props.receipt.url) return props.receipt.url
  if (props.mCode && props.receipt.fileName) {
    const isMerged = props.receipt.fileName.startsWith('merged/')
    if (isMerged) {
      const fileName = props.receipt.fileName.replace('merged/', '')
      return `/api/scan/image/${props.mCode}/merged/${fileName}`
    }
    return `/api/scan/image/${props.mCode}/${props.receipt.fileName}`
  }
  return ''
})

const initForm = () => {
  if (props.receipt) {
    form.value.scanDate = props.receipt.scanDate?.split(' ')[0] || ''
    form.value.description = props.receipt.description || ''
  }
}

const saveChanges = async () => {
  if (!props.receipt || !props.mCode) return

  saving.value = true
  try {
    const fileName = props.receipt.fileName
    const response = await api.put(`/scan/meta/${props.mCode}/${encodeURIComponent(fileName)}`, {
      scanDate: form.value.scanDate,
      description: form.value.description
    })

    if (response.data.success) {
      alert('영수증이 수정되었습니다.')
      emit('saved')
      closeDialog()
    } else {
      alert(response.data.message || '수정에 실패했습니다.')
    }
  } catch (error: any) {
    console.error('영수증 수정 오류:', error)
    alert(error.response?.data?.message || '영수증 수정에 실패했습니다.')
  } finally {
    saving.value = false
  }
}

const closeDialog = () => {
  dialogVisible.value = false
}

watch(() => props.modelValue, (open) => {
  if (open) initForm()
})

watch(() => props.receipt, () => {
  if (props.modelValue) initForm()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
    "max-width": "500",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("mdi-pencil", -1)
              ]))]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "영수증 수정", -1))
          ]),
          _createElementVNode("button", {
            class: "close-btn",
            onClick: closeDialog
          }, [
            _createVNode(_component_v_icon, { size: "20" }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: imageUrl.value,
            alt: __props.receipt?.fileName || ''
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", null, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-calendar", -1)
                ]))]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" 날짜 ", -1))
            ]),
            _createVNode(YmdDateInput, {
              modelValue: form.value.scanDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.scanDate) = $event)),
              class: "form-input"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-text", -1)
                ]))]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" 적요 ", -1))
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.description) = $event)),
              class: "form-input",
              placeholder: "영수증 내용을 입력하세요",
              maxlength: "100"
            }, null, 512), [
              [_vModelText, form.value.description]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn-cancel",
            onClick: closeDialog
          }, " 취소 "),
          _createElementVNode("button", {
            class: "btn-save",
            onClick: saveChanges,
            disabled: saving.value
          }, [
            (saving.value)
              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                  key: 0,
                  indeterminate: "",
                  size: "16",
                  width: "2",
                  color: "white"
                }))
              : (_openBlock(), _createBlock(_component_v_icon, {
                  key: 1,
                  size: "16"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-content-save", -1)
                  ]))]),
                  _: 1
                })),
            _cache[11] || (_cache[11] = _createTextVNode(" 저장 ", -1))
          ], 8, _hoisted_10)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})